import attr from './attr'
import json from './json'

export { default as pk } from './pk'
export { default as string } from './string'
export { default as attr } from './attr'
export { default as createDecoder } from './createDecoder'
export { default as badResponse } from './badResponse'
export { default as toJson } from './toJson'
export const double = attr('float', { precision: 15 })
export const emptyString = attr('string', '')
export const list = (options, or = null) => attr('list', { options, or })
export const timestamp = (format, or) => attr('timestamp', { format, or })
export default json
